import { deleteHistoryItem, HistoryItem as THistoryItem } from "../../services/db";
import { speakText } from "../../services/polly";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

type HistoryItemProps = {
	historyItem: THistoryItem;
};

const HistoryItem = ({ historyItem }: HistoryItemProps) => {
	const handlePlayClick = () => speakText(historyItem.text);

	const handleDelete = () => deleteHistoryItem(historyItem.id);

	return (
		<div className="stored-text-entry-wrapper" style={{ marginBottom: "1rem" }}>
			<div onClick={handlePlayClick} className="icon-wrapper" aria-label="play entry">
				<PlayCircleIcon />
			</div>
			<div className="text" onClick={handlePlayClick}>
				{historyItem.text}
			</div>
			<div onClick={handleDelete} className="icon-wrapper" aria-label="delete entry">
				<HighlightOffIcon onClick={handleDelete} />
			</div>
		</div>
	);
};

export default HistoryItem;
